import { BellIcon } from "@heroicons/react/24/outline";
import { Progress } from "@/components/ui/progress/progress";
import { Button } from "@/components/ui/button";
import { FullPageLoader } from "@/components/fallbacks";

/* Prop Types */
interface AnalysingVideosModalProps {
  succeededCount: number;
  totalCount: number;
  onClose: () => void;
}

/*
 * AnalysingVideosModal component
 * Shows live progress while a video study is being processed. Rendered inline (not via the modal store)
 * so it can react to the live succeededCount/totalCount props from the process route's status poll.
 */
export const AnalysingVideosModal = ({ succeededCount, totalCount, onClose }: AnalysingVideosModalProps) => {
  /* Render */
  return (
    <FullPageLoader className="max-w-lg">
      <div className="flex flex-col items-center gap-4 text-center">
        {/* 
        ------------------
          Add in video gif  
        ------------------
        */}
        <h2>Analysing videos</h2>
        <p>
          {succeededCount} of {totalCount || "…"}
        </p>
        <Progress value={totalCount > 0 ? (succeededCount / totalCount) * 100 : 0} staticColorClass="bg-success" className="w-full" />
        <div>
          <p className="opacity-70 text-sm">Video studies can take a while.</p>
          <p className="opacity-70 text-sm">Analysis keeps running even if you close this window.</p>
        </div>

        <div className="flex gap-2">
          {/* TODO: wire up email-on-completion once a notification endpoint exists (no backend today) */}
          <Button disabled title="Coming soon">
            <BellIcon className="size-4" />
            Email me when done
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </FullPageLoader>
  );
};
